const React = require('react');
const { default: Checkbox } = require('@mui/material/Checkbox');
const { default: Chip } = require('@mui/material/Chip');
const { default: FilledInput } = require('@mui/material/FilledInput');
const { default: FormControl } = require('@mui/material/FormControl');
const { default: InputLabel } = require('@mui/material/InputLabel');
const { default: ListItemText } = require('@mui/material/ListItemText');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { default: Select } = require('@mui/material/Select');
const { default: Styled } = require('styled-components');
const DropdownOptionStyles = require('./dropdownOptionStyles');
const OptionUtils = require('./options');

const internals = {};

module.exports = function FormMultiSelectField(props) {
    const {
        StyledMenuItem,
        TagList,
        ValueChip
    } = internals;

    const {
        field = {},
        formControlProps = field.formControlProps || {},
        inputLabelProps = field.inputLabelProps || {},
        label = field.label,
        onBlur,
        onChange,
        onFocus,
        options = field.options || [],
        required = field.required,
        selectProps = {},
        setValue,
        value = []
    } = props;
    const labelId = selectProps.labelId || `${field.name}-label`;
    const labelText = `${label}${required ? ' *' : ''}`;
    const selectedValues = Array.isArray(value) ? value : [];
    const menuProps = DropdownOptionStyles.mergeLimitedMenuProps(
        selectProps.MenuProps || {},
        DropdownOptionStyles.getVisibleMenuItemCount(options)
    );
    const renderValue = selectProps.renderValue || field.renderValue || ((selected) => (
        <TagList>
            {selected.map((selectedValue) => {

                const option = options.find((_option) => OptionUtils.getOptionValue(_option) === selectedValue);
                return <ValueChip
                    key={selectedValue}
                    label={option ? OptionUtils.getOptionLabel(option) : selectedValue}
                />;
            })}
        </TagList>
    ));

    return <FormControl fullWidth variant='filled' {...formControlProps}>
        <InputLabel id={labelId} error={!!field.error} {...inputLabelProps}>
            {labelText}
        </InputLabel>
        <Select
            {...selectProps}
            labelId={labelId}
            multiple
            value={selectedValues}
            onBlur={onBlur}
            onChange={(event) => {

                let nextValue = event.target.value;

                if (typeof onChange === 'function') {
                    const returnedValue = onChange(nextValue, event);
                    nextValue = typeof returnedValue === 'undefined' ? nextValue : returnedValue;
                }

                if (typeof setValue === 'function') {
                    setValue(nextValue, event);
                }
            }}
            onFocus={onFocus}
            input={<FilledInput />}
            renderValue={renderValue}
            MenuProps={menuProps}
            inputProps={{
                ...(selectProps.inputProps || {}),
                'aria-labelledby': labelId,
                'aria-label': selectProps.inputProps?.['aria-label'] || labelText
            }}
        >
            {options.map((option) => {

                const optionValue = OptionUtils.getOptionValue(option);
                const optionLabel = OptionUtils.getOptionLabel(option);

                return <StyledMenuItem key={optionValue} value={optionValue}>
                    <Checkbox checked={selectedValues.includes(optionValue)} />
                    <ListItemText primary={optionLabel} />
                </StyledMenuItem>;
            })}
        </Select>
    </FormControl>;
};

internals.TagList = Styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing(0.5)};
`;

internals.ValueChip = Styled(Chip)`
    height: 22px;
`;

internals.StyledMenuItem = Styled(MenuItem)`
    ${DropdownOptionStyles.option}
    align-items: center !important;
`;
